import { render, staticRenderFns } from "./VisitorItem.vue?vue&type=template&id=28c17b17"
import script from "./VisitorItem.vue?vue&type=script&lang=js"
export * from "./VisitorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports